import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import { Button, FormGroup, CircularProgress, Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import adminManagementService from '../../../services/AdminManagementService';
import { emptyAdminProfile } from '../fixtures';
import { Admin } from '../../../interfaces/Admin';
import { getStyles } from '../styles';


interface ReactivateAdminModalProps {
    open: boolean;
    handleClose: (reactivate?: boolean) => void;
    profile: Admin;
}

export default function ReactivateAdminModal(props: ReactivateAdminModalProps) {
    const theme = useTheme();
    const styles = getStyles(theme);
    const [profile, setProfile] = useState<Admin>(emptyAdminProfile);
    const [isLoading, setLoading] = useState(false);
    const [hasErr, setHasErr] = useState(false);

    useEffect(() => {
        setProfile(props.profile);
    }, [props.profile]);

    const submitForm = async () => {
        setHasErr(false);
        setLoading(true);
        const success = await adminManagementService.reactivateAdmin(profile.id!);
        setLoading(false);
        if (success) props.handleClose(true);
        if (!success) setHasErr(true);
    };

    return (
        <Modal
            aria-labelledby="reactivate-admin-modal-title"
            aria-describedby="reactivate-admin-modal-description"
            data-cy="activate-admin-modal"
            open={props.open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    props.handleClose();
                }
            }}
        >
            <Box sx={{ ...styles.paper, ...styles.modal }}>
                <h2 id="reactivate-admin-modal-title">You are about to reactivate {profile?.username || " "}</h2>
                {hasErr ? <Typography sx={styles.redTxt}> Failed to reactivate admin </Typography> : undefined}
                <FormGroup sx={[styles.mt2, styles.dfr]}>
                    <Button data-cy="reactivate-button" variant="contained" sx={styles.btnDanger} onClick={submitForm}>Reactivate</Button>
                    <Button
                        data-cy="close-button"
                        variant="contained"
                        onClick={() => props.handleClose(false)}
                        sx={styles.ml2}>Close</Button>
                </FormGroup>
                {isLoading ? <CircularProgress color="primary" /> : undefined}
            </Box>
        </Modal>
    );
}